module.exports = __webpack_public_path__ + "img/category.aa920fba.svg";